<template>
  <div class="addControl">
    <!--新增部门组-->
    <el-dialog
      title="新增部门组"
      :visible.sync="dialogAdd"
      :close-on-click-modal="false"
      width="80%"
    >
      <el-tabs type="border-card">
        <el-tab-pane label="部门组信息">
          <base-form
            v-model="formData"
            :options="optionsForm"
            ref="formData"
            @input="handleChange"
            label-width="100px"
          >
          </base-form>
          <div class="department-content">{{ this.$t('company.controlRangeTitle') }}</div>
          <!--新增/删除按钮-->
          <vxe-toolbar>
            <template v-slot:buttons>
              <vxe-button
                type="primary"
                icon="el-icon-plus"
                class="vxe-btn-primary"
                @click="insertEvent()"
                >{{ $t('xTable.insert') }}</vxe-button
              >
              <vxe-button
                type="primary"
                icon="el-icon-delete"
                class="vxe-btn-delete"
                @click="deleteEvent()"
                >{{ $t('xTable.delete') }}</vxe-button
              >
            </template>
          </vxe-toolbar>
          <!---可编辑表格-->
          <vxe-table
            border
            size="mini"
            show-overflow
            show-header-overflow
            ref="xTable"
            class="edit-table"
            :height="80"
            :max-height="180"
            :data="tableData"
            :edit-rules="validRules"
            :edit-config="{ trigger: 'click', mode: 'row', showStatus: true }"
          >
            <vxe-table-column type="checkbox" width="50"></vxe-table-column>
            <vxe-table-column type="seq" width="60" :title="$t('table.index')"></vxe-table-column>
            <vxe-table-column
              field="interestDepartmentCode"
              title="计息部门名称"
              :editRender="{
                name: 'ElSelect',
                props: { clearable: true, filterable: true },
                options: this.departmentList,
                events: { change: (obj) => this.updateCol(obj.row, 'interestDepartmentCode') },
              }"
            >
            </vxe-table-column>
            <vxe-table-column field="interestDepartmentCode" title="计息部门编码">
            </vxe-table-column>
            <vxe-table-column
              field="inDate"
              title="调整部门组日期"
              :editRender="{
                name: 'ElDatePicker',
                props: { clearable: true, valueFormat: 'yyyy-MM-dd' },
              }"
            >
            </vxe-table-column>
            <vxe-table-column
              field="outDate"
              title="离开部门组日期"
              :editRender="{
                name: 'ElDatePicker',
                props: { clearable: true, valueFormat: 'yyyy-MM-dd' },
              }"
            >
            </vxe-table-column>
          </vxe-table>
        </el-tab-pane>
      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" @click="addSure()">{{
          $t('dialog.confirm')
        }}</el-button>
        <el-button @click="dialogAdd = false">{{ $t('dialog.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/masterData/intersetGroup.js';
  // import { isEqual } from '@/common/js/util';
  import BaseForm from '@/components/form/base-form';
  import XEUtils from 'xe-utils';
  export default {
    name: 'addControl',
    components: {
      BaseForm,
    },
    props: ['departmentList', 'companyList'],
    data() {
      return {
        dialogAdd: false,
        loading: false,
        formData: {
          interestGroupName: null,
          interestGroupCode: null,
          interestCompanyName: null,
          interestCompanyCode: null,
        },
        tableData: [],
        options: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      optionsForm() {
        return [
          {
            type: 'input',
            label: '计息部门组名称',
            prop: 'interestGroupName',
            clearable: true,
            disabled: false,
            required: true,
            span: 12,
          }, //计息部门组名称
          {
            type: 'input',
            label: '计息部门组编码',
            prop: 'interestGroupCode',
            clearable: true,
            disabled: false,
            required: false,
            span: 12,
          }, //计息部门组名称
          {
            type: 'select',
            options: this.companyList,
            label: '计息公司',
            prop: 'interestCompanyCode',
            clearable: true,
            disabled: false,
            required: true,
            span: 12,
          }, //计息公司
          {
            type: 'input',
            label: '计息公司编码',
            prop: 'interestCompanyCode',
            clearable: true,
            disabled: true,
            required: true,
            span: 12,
          }, //计息公司编码
        ];
      },
      validRules() {
        return {
          interestDepartmentCode: [{ required: true, message: '请选择部门' }],
          inDate: [{ required: true, message: '请选择调整部门组日期' }],
        };
      },
    },
    methods: {
      openDialog(flag) {
        this.tableData = [];
        this.loading = false;
        this.dialogAdd = flag;
        this.formData = {
          interestGroupName: null,
          interestGroupCode: null,
          interestCompanyName: null,
          interestCompanyCode: null,
        };
      },
      // 表单变化
      handleChange(v, prop) {
        console.log(v[prop]);
        this.formData[prop] = v[prop];
        if (prop == 'interestCompanyCode') {
          this.formData.interestCompanyName = v[prop]
            ? this.companyList.find((it) => it.value == v[prop])?.label
            : '';
          this.tableData = [];
          // 获取部门信息
          this.$emit('getdepartmentList', this.formData.interestCompanyCode);
        }
      },
      // 表格变化
      updateCol(row, prop) {
        console.log(row);
        if (prop == 'interestDepartmentCode') {
          row.interestDepartmentName = row[prop]
            ? this.departmentList.find((it) => it.value == row[prop])?.label
            : '';
        }
      },
      //新增一行
      insertEvent() {
        // const tableList = this.$refs.xTable.getTableData().fullData;
        this.$refs.xTable.validate((valid) => {
          if (valid) {
            let record = {
              interestDepartmentCode: null,
              interestDepartmentName: null,
              inDate: null,
              interestGroupCode: null,
              interestGroupName: null,
            };
            record = this.$baseRequest.assignObj(record);
            this.$refs.xTable.insert(record).then(({ row }) => this.$refs.xTable.setActiveRow(row));
          }
        });
      },
      //删除一行
      deleteEvent() {
        let selectRecords = this.$refs.xTable.getCheckboxRecords();
        if (selectRecords.length) {
          this.$refs.xTable.removeSelecteds();
        } else {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
        }
      },

      // 校验付款申请表单
      validateForm() {
        return new Promise((resolve) => {
          this.$refs.formData.handleSubmit().then(() => {
            resolve(true);
          });
        });
      },

      // 获取表格数据并校验

      // 返回数据
      exportChildData() {
        const tableData = this.$refs.xTable.getTableData().fullData;
        console.log(tableData);
        // 点击提交，走校验
        if (tableData.length == 0) {
          return [];
        } else {
          return new Promise((resolve) => {
            this.$refs.xTable.validate().then(() => {
              resolve(tableData);
            });
          });
        }
      },

      //保存
      async addSure() {
        let flag = await this.validateForm(); //校验表单
        if (!flag) return;

        let detailList = await this.exportChildData();

        // this.loading = true;
        this.formData = this.$baseRequest.assignObj(this.formData);
        let params = XEUtils.clone(this.formData, true);
        params.detailList = detailList;
        this.$axios.post(API.INTERSET_GROUP_SAVE, params).then((res) => {
          this.loading = false;
          if (0 != res.data.code) {
            this.$alert(res.data.msg);
          } else {
            this.dialogAdd = false;
            this.$emit('getData');
            this.$message({
              showClose: true,
              message: res.data.msg || this.$t('message.success'),
              type: 'success',
            });
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .department-content {
    font-size: 14px;
    font-weight: 500;
    color: rgba(40, 55, 79, 1);
  }
</style>
